export default ({numOfChars, children}) => {
  return children.length > numOfChars ? children.slice(0, numOfChars) + '...' : children
}
